module.exports = __webpack_public_path__ + "img/126.30a7470b.jpg";